'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const SecondaryNavContext = React.createContext(void 0);
const useSecondaryNavContext = () => {
  const context = React.useContext(SecondaryNavContext);
  if (context === void 0) {
    throw new Error("useSecondaryNavContext must be used within a SecondaryNavContext (which is available by using SecondaryNav)");
  }
  return context;
};

exports.SecondaryNavContext = SecondaryNavContext;
exports.useSecondaryNavContext = useSecondaryNavContext;
//# sourceMappingURL=SecondaryNavContext.cjs.js.map
